<template>
  <div id="homePhone" style="overflow: hidden">
    <BannerPhone></BannerPhone>
    <CoupsDeCoeurHomePhone :user="user" @connection="openModal" :lodgings="cdc_lodgings" />
    <PropositionsPhone></PropositionsPhone>
    <ClubHortensePhone />
    <LodginghomePhone @connection="openModal" :user='user' :lodgings="lodgings" v-if='lodgings.length > 0'></LodginghomePhone>
    <CollectionHomePhone :collections='collections' v-if='collections.length > 0'></CollectionHomePhone>
    <ExperienceHomeNewPhone />
    <AccommodationPhoneCard :user='user' :lodgings="accommodations" @collectionSelected="selectedCollection = $event" v-if='accommodations.length > 0'></AccommodationPhoneCard>
    <!-- <ExperienceHortense @connection="openModal" /> -->
    <!-- <SeasonsCard></SeasonsCard> -->
    
    
<!--    <ExclusiveHomePhone :exclusives="exclusives" v-if='exclusives.length > 0'></ExclusiveHomePhone>-->
<!--    <WeekendPhone :weekends="weekends" v-if='weekends.length > 0'></WeekendPhone>-->
<!--    <ExpehomePhone :experiencesByCategory="experiences" v-if=" Object.keys(experiences).length > 0"></ExpehomePhone>-->
    <!-- <GiftCardPhone></GiftCardPhone> -->
    <DestinationPhone :destinations="destinations" v-if='destinations.length > 0'></DestinationPhone>
    <BecomeHostPhone />
    <!-- <TipsPhone></TipsPhone> -->
    <!-- <EvergreenPhoneHome></EvergreenPhoneHome> -->
    <!-- <LabelhomePhone></LabelhomePhone> -->
    <!-- <WhoisPhone></WhoisPhone> -->
    <!-- <FidPhone :user='user' @connection="openModal"></FidPhone> -->
    <!-- <ScrollUp></ScrollUp> -->
    <a class="sticky hortense-btn-primary raleway-bold-p" href="/reservation-hotel" v-if="scrolled">{{ $t('LodgingCard.view') }}</a>
    <!-- <ReaPhone></ReaPhone> -->
  </div>
</template>

<script>
  import fetcher from 'packs/shared/api.js';
  import BannerPhone from '../components/BannerPhone.vue';
  import PropositionsPhone from 'components/PropositionsPhone.vue';
  import TipsPhone from 'components/TipsPhone.vue';
  import LodginghomePhone from 'components/LodginghomePhone.vue';
  import WeekendPhone from 'components/WeekendPhone.vue';
  import ExclusiveHomePhone from 'components/exclusive/ExclusiveHomePhone.vue';
  import ExpehomePhone from 'components/ExpehomePhone.vue';
  import GiftCardPhone from "../components/GiftCardPhone.vue";
  import DestinationPhone from 'components/DestinationPhone.vue';
  import CollectionHomePhone from 'components/collection/CollectionHomePhone.vue';
  import EvergreenPhoneHome from 'components/EvergreenPhoneHome.vue';
  import LabelhomePhone from 'components/LabelhomePhone.vue';
  import WhoisPhone from 'components/WhoisPhone.vue';
  import FidPhone from 'components/FidPhone.vue';
  import ScrollUp from 'components/btns/ScrollUp.vue';
  import AccommodationPhoneCard from "../components/cards/AccommodationPhoneCard.vue";
  import ExperienceHortense from "../components/ExperienceHortense.vue";
  import SeasonsCard from '../components/cards/SeasonsCard.vue';
  import BecomeHostPhone from "../components/BecomeHostPhone.vue";
  import ClubHortensePhone from "../components/ClubHortensePhone.vue";
  import CoupsDeCoeurHomePhone from "../components/CoupsDeCoeurHomePhone.vue";
  import ExperienceHomeNewPhone from '../components/ExperienceHomeNewPhone.vue';
  // import ReaPhone from 'components/ReaPhone.vue';

  export default {
    name: 'homePhone',
    props: ['user', 'cdc_lodgings'],
    components: { ExperienceHortense, BannerPhone, TipsPhone, PropositionsPhone, LodginghomePhone, WeekendPhone, ExclusiveHomePhone, ExpehomePhone, DestinationPhone, CollectionHomePhone, EvergreenPhoneHome, LabelhomePhone, WhoisPhone, FidPhone, ScrollUp, GiftCardPhone, AccommodationPhoneCard, SeasonsCard, BecomeHostPhone, ClubHortensePhone, CoupsDeCoeurHomePhone, ExperienceHomeNewPhone },
    data() {
      return {
        showBanner: false,
        lodgings: [],
        weekends: [],
        experiences: {},
        destinations: [],
        collections: [],
        scrolled: false,
        accommodations: [],
        coupsDeCoeurLodgings: null,
        selectedCollection: null
      }
    },
    methods: {
      openModal() {
        this.$root.$emit('openModal')
      },
      redirectToTop() {
         window.scrollTo(0, '#navbar');
      },
      handleScroll () {
        const top =	window.pageYOffset;
        const bottom = document.body.scrollHeight - (window.innerHeight + window.scrollY);
        const footer_height = document.getElementById('p-footer').offsetHeight;
        if (top > 500 && bottom > footer_height) {
          this.scrolled = true;
        } else {
          this.scrolled = false;
        }
      },
      async fetchdatas() {
        try {
          // Parallelize all API requests for better performance
          const requests = [
            fetcher.get('/reservation-hotel?page=1&lodgings_count=3'),
            fetcher.get('/weekends'),
            fetcher.get('/basic/experiences'),
            fetcher.get('/destination', {
              params: { countries: ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE'] }
            }),
            fetcher.get('/collections')
          ];

          const [
            responseLodging,
            responseWeekend,
            responseExperience,
            responseDestination,
            responseCollection,
            responseEvergreen
          ] = await Promise.all(requests);

          // Assign data
          this.lodgings = responseLodging.data;
          this.weekends = responseWeekend.data;
          this.experiences = responseExperience.data;
          this.destinations = responseDestination.data;
          this.collections = responseCollection.data;

          // Fetch home lodgings after critical data is loaded
          await this.fetchHomeLoadings();
        } catch(e) {
          console.error('Error fetching home data:', e);
        }
      },
      async fetchHomeLoadings() {
        try {
          const responseAccommodation = await fetcher.get(
            "/home_lodgings", {
              params: { collection: this.selectedCollection }
            }
          );
          this.accommodations = responseAccommodation.data;
        } catch(e) {
          console.error('Error fetching home lodgings:', e);
        }
      },
    },
    mounted() {
      this.fetchdatas();
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
      selectedCollection() {
        this.fetchHomeLoadings();
      },
      scrolled: {
        handler(newVal) {
          const whatsappBtn = document.getElementById('whatsapp-button');
          if (whatsappBtn) {
            whatsappBtn.style.display = newVal ? 'block' : 'none';
          }
        },
        immediate: true
      }
    }
};
</script>
<style scoped>
  #homePhone {
    .hortense-btn-primary {
      width: 100% !important;
    }
  }
</style>